interface PaginationParams {
  currentPage: number;
  totalPages: number;
  itemsPerPage: number;
  availableItems: number;
}
export const paginationPluralizeResult = (
  params: PaginationParams | undefined,
  items: number | undefined,
) => {
  if (params) {
    const startItem = (params.currentPage - 1) * params.itemsPerPage + 1;
    const endItem = Math.min(startItem + (items ?? 0) - 1, params.availableItems);
    return `Displaying ${startItem}–${endItem} of ${params.availableItems} results`;
  }

  return `Displaying 0–0 of 0 results`;
};
